import { styled } from 'stitches.config'
import Link from 'next/link'

export const HeroRoot = styled('section', {
  background: '$tertiary-200',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
})

export const HeroContent = styled('div', {
  maxWidth: '1920px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',

  '@bp2': {
    flexDirection: 'row',
    alignItems: 'center',
  },
})

export const HeroImage = styled('div', {
  position: 'relative',
  width: '100%',
  display: 'none',
  lineHeight: 0,

  '@bp2': {
    width: '50%',
    display: 'block',
  },
})

export const HeroImageMobile = styled('div', {
  position: 'relative',
  display: 'block',
  '@bp2': {
    display: 'none',
  },
})

export const HeroTextContent = styled('div', {
  width: '100%',
  padding: '$4',
  paddingBottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '359px',
  position: 'relative',

  '@bp2': {
    width: '50%',
    padding: '$6',
    maxWidth: 'none',
  },
})

export const HeroBadge = styled('div', {
  position: 'absolute',
  top: '-46px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '80px',
  height: '80px',

  '&.desktop-only': {
    display: 'none',
  },

  '&.mobile-only': {
    display: 'block',
  },

  '@bp2': {
    display: 'block',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100px',
    height: '100px',
    '&.desktop-only': {
        display: 'block',
      },
    
      '&.mobile-only': {
        display: 'none',
      }
    
  },'@bp4': {
    width: '163px',
    height: '163px',
  },

})

export const HeroTitle = styled('h1', {
  color: '$primary-500',
  textAlign: 'center',
  fontFamily: '$display',
  fontSize: '$h2',
  fontWeight: '$medium',
  lineHeight: '1.0',
  marginBottom: '$2',
  marginTop: '$4',

    '@bp2': {
        fontSize: '$h1',
        maxWidth: '500px',
        marginTop: 0,
    },

  '@bp4': {
    fontSize: '90px',
    lineHeight: '100px',
    maxWidth: '733px',
  },
})

export const HeroSubtitle = styled('p', {
  color: '$accent-black',
  textAlign: 'center',
  fontFamily: '$primary',
  fontSize: '$h5',
  fontWeight: '$regular',
  lineHeight: '1.0',
  marginBottom: '$4',
  width: '260px',


  '@bp2': {
    fontSize: '$h4',
    maxWidth: '733px',
    width: '100%',
    marginBottom: '$4',
  },
})

export const HeroCtaContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$2',
  padding: '$1 $4 $4 $4',
  width: '100%',
  background: '$tertiary-200',
  '& span': { cursor: 'pointer' },

  '@bp2': {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '$4',
    background: '$tertiary-200',
    padding: '$4',
  },

  '@bp3': {
    gap: '$6'
  },

  '@bp4': {
    gap: '$8',
  }
})

export const HeroCtaLink = styled('span', {
  color: '$accent-black',
  fontFamily: '$primary',
  fontSize: '$body',
  fontWeight: '$medium',
  textDecoration: 'none',
  borderBottom: '1px solid $primary-700',
  transition: 'all 0.2s ease-in-out',
  textAlign: 'center',
  width: 'auto',
  maxWidth: '300px',
  padding: 0,

  '&:hover': {
    color: '$primary-500',
    borderBottomColor: '$primary-500',
  },

  '@bp2': {
    fontSize: '$headline',
    width: 'auto',
    maxWidth: 'none',
    padding: 0,
   
  },

})